import React from "react";

type CheckedIconProps = React.SVGProps<SVGSVGElement>;

export const CheckedIcon = ({
  width = 20,
  height = 20,
  ...props
}: CheckedIconProps) => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}> 
<mask id="path-1-inside-1_209_66547" fill="white">
<path d="M17 3V8H21V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V7C3 4.79086 4.79086 3 7 3H17Z"/>
</mask>
<path d="M17 3V8H21V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V7C3 4.79086 4.79086 3 7 3H17Z" fill="#DFECFF"/>
<path d="M17 3H18V2H17V3ZM17 8H16V9H17V8ZM21 8H22V7H21V8ZM17 21V22V21ZM3 17H2H3ZM7 3V2V3ZM17 3H16V8H17H18V3H17ZM17 8V9H21V8V7H17V8ZM21 8H20V17H21H22V8H21ZM21 17H20C20 18.6569 18.6569 20 17 20V21V22C19.7614 22 22 19.7614 22 17H21ZM17 21V20H7V21V22H17V21ZM7 21V20C5.34315 20 4 18.6569 4 17H3H2C2 19.7614 4.23858 22 7 22V21ZM3 17H4V7H3H2V17H3ZM3 7H4C4 5.34315 5.34315 4 7 4V3V2C4.23858 2 2 4.23858 2 7H3ZM7 3V4H17V3V2H7V3Z" fill="#5A8DF1" mask="url(#path-1-inside-1_209_66547)"/>
<path d="M16 3H17C19.2091 3 21 4.79086 21 7V9H16V3Z" fill="#DFECFF"/>
<path d="M8 9.5L11.9262 13.2954C12.3272 13.6829 12.9677 13.6677 13.3497 13.2615L23 3" stroke="#5A8DF1" stroke-width="1.5" stroke-linecap="round"/>
</svg>

  
);

export default CheckedIcon;
